/**
 * Content-writer intent detection — mirrors the backend patterns in
 * /app/backend/content_writer_prompt.py so the client can preview which
 * specialist will fire before hitting the server.
 *
 * Kept intentionally lightweight — the regex list is duplicated on
 * purpose (rather than fetched from an endpoint) so it works instantly
 * inside the composer without a round-trip on every keystroke.
 *
 * Keep in sync with `_TYPE_PATTERNS` in content_writer_prompt.py.
 */

const PATTERNS = [
  // Legal
  ["privacy_policy",     /\b(privacy policy|privacy notice|gdpr policy|ccpa policy)\b/i],
  ["terms",              /\b(terms of service|terms & conditions|terms and conditions|t&cs?|user agreement|eula)\b/i],
  ["legal_disclaimer",   /\b(legal disclaimer|liability disclaimer|risk disclaimer|not liable)\b/i],
  ["contract_clause",    /\b(contract clause|contract for|nda|non[- ]disclosure|non[- ]compete|employment contract|service agreement|indemnity|arbitration clause)\b/i],
  // Technical
  ["api_doc",            /\b(api docs?|api documentation|openapi spec|swagger spec|endpoint (docs?|reference))\b/i],
  ["readme",             /\b(readme|readme\.md|project readme|github readme|library readme)\b/i],
  // Marketing
  ["blog_post",          /\b(blog post|article|long[- ]form article|seo article|blog draft)\b/i],
  ["email",              /\b(cold email|newsletter|drip email|welcome email|announcement email|email campaign)\b/i],
  ["ad_copy",            /\b(ad copy|google ads?|facebook ads?|meta ads?|ppc copy|display ad copy)\b/i],
  ["press_release",      /\b(press release|announcement release|pr for|media release)\b/i],
  // Thought leader
  ["thought_leadership", /\b(thought leadership|op[- ]?ed|opinion piece|essay|position paper)\b/i],
  // Social + personal
  ["linkedin",           /\b(linkedin post|linkedin caption|linkedin update)\b/i],
  ["x_twitter",          /\b(tweet|twitter post|x post|thread|x thread)\b/i],
  ["instagram_caption",  /\b(instagram caption|ig caption|insta caption|reel caption)\b/i],
  ["personal_story",     /\b(personal story|founder story|origin story|my story)\b/i],
];

const LABELS = {
  linkedin: "LinkedIn post", x_twitter: "Twitter/X thread",
  instagram_caption: "Instagram caption", personal_story: "Personal story",
  blog_post: "Blog post", email: "Email", ad_copy: "Ad copy",
  press_release: "Press release", thought_leadership: "Thought leadership",
  readme: "README", api_doc: "API docs",
  privacy_policy: "Privacy policy", terms: "Terms of service",
  legal_disclaimer: "Legal disclaimer", contract_clause: "Contract clause",
};

/** Return the matched content type id or null. */
export function detectContentType(text) {
  if (!text || text.length < 6) return null;
  for (const [id, re] of PATTERNS) {
    if (re.test(text)) return id;
  }
  return null;
}

export function contentTypeLabel(id) {
  return LABELS[id] || id;
}
